import * as pdfjsLib from 'pdfjs-dist'

// Worker URL is pinned to the installed package version so the two can never
// drift (pdfjs refuses to load a mismatched worker).
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`

export { pdfjsLib }
